<template>
  <form autocomplete="off" class="">
    <div class="row justify-content-center">
        <div class="col-lg-12">
            <div v-if="!editItem.gender || !editItem.dob || !editItem.marital_status" class="card bg-light">
                <div class="card-body">
                    <div class="row gy-3">
                        <div v-if="!editItem.gender" class="col-lg-5">
                            <label for="gender" class="form-label">Gender <span class="text-danger">*</span></label>
                            <select v-model="data.gender" name="gender" id="gender" class="form-select"
                            :class="{ 'is-invalid': v$.data.gender.$error }" >
                            <option disabled :value="null" >--select gender--</option>
                            <option v-for="(gender, gdIndex) in genderOptions" :key="gdIndex" 
                                :value="gender.value">{{gender.label}}</option>
                            </select>
                            <div v-for="(item, index) in v$.data.gender.$errors"
                                :key="index" class="invalid-feedback">
                                <span v-if="item.$message">{{ item.$message }}</span>
                            </div> 
                        </div>
                        <div v-if="!editItem.dob" class="col-lg-7">
                            <label class="form-label">
                                Date of birth <span class="text-danger">*</span>
                            </label>
                            <div class="input-group">
                                <select @change="createDOB()" v-model="manualDate.day" name="day"
                                    :class="{ 'is-invalid': v$.data.dob.$error  }" class="form-select">
                                    <option disabled value="">Day </option>
                                    <option v-for="(day, dIndex) in days" :key="dIndex"
                                        :value="day.value">{{day.label}}</option>
                                </select>
                                <select @change="createDOB()" v-model="manualDate.month" name="month"
                                :class="{ 'is-invalid': v$.data.dob.$error  }" class="form-select">
                                    <option disabled value="">Month</option>
                                    <option v-for="(month, mIndex) in months" :key="mIndex"
                                    :value="month.value">{{month.label}}</option>
                                </select>
                                <select @change="createDOB()" v-model="manualDate.year" name="year"
                                    :class="{ 'is-invalid': v$.data.dob.$error  }" class="form-select">
                                    <option disabled value=""> Year </option>
                                    <option v-for="(year, yIndex) in years" :key="yIndex"
                                    :value="year.value">{{year.label}}</option>
                                </select>
                            </div>
                            <div v-for="(item, index) in v$.data.dob.$errors"
                                :key="index" class="text-danger">
                                <span v-if="item.$message">{{ item.$message }}</span>
                            </div> 
                            <div v-if="data.age" class="mt-2">
                                <span class="text-primary">AGE: {{data.age}} Years old</span>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <label class="form-label">Marital Status <span class="text-danger">*</span></label>
                            <select v-model="data.marital_status" name="marital_status" class="form-select"
                            :class="{ 'is-invalid': v$.data.marital_status.$error }" >
                            <option disabled :value="null" >--select status--</option>
                            <option v-for="(mastatus, gdIndex) in maritalOptions" :key="gdIndex" 
                                :value="mastatus.value">{{mastatus.label}}</option>
                            </select>
                            <div v-for="(item, index) in v$.data.marital_status.$errors"
                                :key="index" class="invalid-feedback">
                                <span v-if="item.$message">{{ item.$message }}</span>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
            <div class="card bg-light loading-viewport">
                <is-loading v-if="isLoading" :box="true" />
                <div class="card-body">
                    <div class="row gy-3">
                        <div class="col-12" >
                            <h5 class="mb-2">Residential Address</h5>
                        </div>
                        <div class="col-12">
                            <label for="street_address" class="form-label">Street Address <span class="text-danger">*</span> </label>
                            <input v-model="data.residential_address.street_address"
                                id="street_address"  name="street_address" 
                                :class="{ 'is-invalid': v$.data.residential_address.street_address.$error }"
                                class="form-control" type="text" placeholder="Street Address">
                            <div v-for="(item, index) in v$.data.residential_address.street_address.$errors"
                                :key="index" class="invalid-feedback">
                                <span v-if="item.$message">{{ item.$message }}</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label for="residential_address_state" class="form-label">State of residence <span class="text-danger">*</span></label>
                            <select @change="stateChange()" v-model="data.residential_address.state_id" name="residential_address_state" id="residential_address_state" class="form-select"
                                :class="{ 'is-invalid': v$.data.residential_address.state_id.$error }">
                                <option disabled value="" >--select state--</option>
                                <option v-for="(state, lgIndex) in stateOptions" :key="lgIndex" 
                                :value="state.id">{{state.name}}</option>
                            </select>
                            <div v-for="(item, index) in v$.data.residential_address.state_id.$errors"
                                :key="index" class="invalid-feedback">
                                <span v-if="item.$message">{{ item.$message }}</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label for="residential_address_lga" class="form-label">LGA of residence <span class="text-danger">*</span></label>
                            <select v-model="data.residential_address.local_government_id" name="residential_address_lga" id="residential_address_lga" class="form-select"
                                :class="{ 'is-invalid': v$.data.residential_address.local_government_id.$error }">
                                <option disabled value="" >--select LGA--</option>
                                <option v-for="(residentLga, lgIndex) in residentLgaOptions" :key="lgIndex" 
                                :value="residentLga.id">{{residentLga.name}}</option>
                            </select>
                            <div v-for="(item, index) in v$.data.residential_address.local_government_id.$errors"
                                :key="index" class="invalid-feedback">
                                <span v-if="item.$message">{{ item.$message }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card bg-light loading-viewport">
                <is-loading v-if="validAccount.loading" :box="true" />
                <div class="card-body">
                    <div class="row gy-3">
                        <div class="col-12" >
                            <h5 class="mb-2">Bank Account Details</h5>
                        </div>
                        <div class="col-sm-6">
                            <label class="form-label" for="account_number">Account number <span class="text-danger">*</span></label>
                            <input @blur="verifyAccount()" id="account_number" type="text" class="form-control"
                            v-model="data.bank_account.account_number"
                            placeholder="Account number" name="account_number"
                            :class="{ 'is-invalid': v$.data.bank_account.account_number.$error }" />
                            <div v-for="(item, index) in v$.data.bank_account.account_number.$errors"
                                :key="index" class="invalid-feedback">
                                <span v-if="item.$message">{{ item.$message }}</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label class="form-label" for="bank_id">Bank name <span class="text-danger">*</span></label>
                            <select @change="verifyAccount()" v-model="data.bank_account.bank_id"
                            name="bank_id" id="bank_id" class="form-select"
                            :class="{ 'is-invalid': v$.data.bank_account.bank_id.$error }">
                                <option disabled value="" >--select bank--</option>
                                <option v-for="(bank, bIndex) in bankOptions" :key="bIndex" 
                                :value="bank.id">{{bank.name}}</option>
                            </select>
                            <div v-for="(item, index) in v$.data.bank_account.bank_id.$errors"
                                :key="index" class="invalid-feedback">
                                <span v-if="item.$message">{{ item.$message }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <span v-if="data.bank_account.account_name" class="text-primary">{{data.bank_account.account_name}}</span>
                            <small v-if="validAccount.message" class="text-danger">{{validAccount.message}}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-grid d-sm-block mb-3 mb-sm-0 order-sm-2">
                <button @click.prevent="confirm()" class="btn btn-primary"  type="button">
                    Complete Profile
                </button>
            </div>
        </div>
    </div>
  </form>
</template>

<script>
import { required, email, minLength, maxLength, requiredIf, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import IsLoading from '@/components/IsLoading.vue'
import Multiselect from '@vueform/multiselect'
import { fullAddressMixin } from '@/mixins/fullAddressMixin'
import { dateOfBirthMixin } from '@/mixins/dateOfBirthMixin'

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    mixins:[
        fullAddressMixin,
        dateOfBirthMixin
    ],
    components: {
        IsLoading,
        Multiselect
    },
    props:{
        editItem:{
            type: Object,
            default: null
        }
    },
    data(){
        return{
          isLoading: false,
          data: {
            gender: null,
            dob: null,
            age: "",
            marital_status: null,

            residential_address:{
                street_address: "",
                state_id: "",
                local_government_id: "",
            },

            bank_account:{
                bank_id: "",
                account_name: "",
                account_number: ""
            },
          },
          bankOptions: [],
          validAccount:{
            status: false,
            loading: false,
            message: ""
          },
          genderOptions: [
            { label: 'Male', value: 'male' },
            { label: 'Female', value: 'female' },
            { label: 'Others', value: 'others' }
          ],
          maritalOptions:[
            { label: 'Single', value: 'Single' },
            { label: 'Married', value: 'Married' },
            { label: 'Widowed', value: 'Widowed' },
            { label: 'Divorced', value: 'Divorced' },
          ],
          mirrorData: null,
        }
    },
    validations() {
        return {        
          data:{
            gender: {
                required: helpers.withMessage("Select gender", required),
            },   
            dob: {
                required: helpers.withMessage("Date of birth is required", required),
            }, 
            marital_status: {
                required: helpers.withMessage("Select marital status", required),
            },  
            residential_address:{
                street_address: {
                    required: helpers.withMessage("Street Address is required", required),
                },
                state_id: {
                    required: helpers.withMessage("Residential state is required", required),
                },
                local_government_id: {
                    required: helpers.withMessage("Residential local government is required", required),
                }
            },
            bank_account:{
                bank_id: {
                    required: helpers.withMessage("Select a bank", required),
                },
                account_number: {
                    required: helpers.withMessage("Account number is required", required),
                    maxLength: helpers.withMessage("Account number must be exactly 10 digits", maxLength(10))
                },
                account_name: {
                    required: helpers.withMessage("Account name is required", required),
                },
            },
          }
        }
    },
    computed: {
        activeUser(){
            return this.$store.state.AppActiveUser
        },
    },
    methods:{
        async confirm() {
          const result = await this.v$.$validate();
          if (!result) {
              this.alertError(this.v$.$errors[0].$message);
              return;
          }
          const confirmResult = await this.confirmAction({
              html: "<h6>Acknowledge that all entered details are accurate.</h6>",
          });
          if (confirmResult.value) {
              this.create();
          }
        },
        create() {
            let formData = new FormData();
            formData.append('data', JSON.stringify(this.data))
            this.$store.dispatch("changeLoaderValue", true)
            this.$http.post('/account/complete-profile', formData)
            .then((response) => {
                this.$store.dispatch("changeLoaderValue", false)
                if(response.data.success){
                    this.$emit('addItem', response.data.data)
                    this.resetForm();
                }
            })
        },
        verifyAccount(){
            this.data.bank_account.account_name = this.validAccount.message = "";
            if(!this.data.bank_account.bank_id || !this.data.bank_account.account_number) { return;}
            let payload = { bank_id: this.data.bank_account.bank_id, account_number: this.data.bank_account.account_number}
            this.validAccount.loading = true
            this.validAccount.status = false
            this.$http.post(`${this.absoluteUrl()}/api/verify/bank-account`, payload)
                .then((response) => {
                this.validAccount.loading = false
                if(response.data.success){
                    this.validAccount.status = true
                    this.data.bank_account.account_name = response.data.data.account_name
                }else{
                    this.validAccount.message = response.data.data.message
                }
            })
        },
        resetForm(){
            this.data = {...this.mirrorData}
            this.v$.$reset()
            this.$emit("closeMe")
        },
        getOptionData(){
            this.isLoading = true
            this.$http.get(`${this.absoluteUrl()}/api/states`)
                .then((response) => {
                if(response.data.success){
                    this.stateOptions = response.data.data
                }
            })
            this.$http.get(`${this.absoluteUrl()}/api/banks`)
                .then((response) => {
                this.isLoading = false
                if(response.data.success){
                    this.bankOptions = response.data.data
                }
            })
        },
        setAvailableData(){
            this.data.gender = this.editItem.gender || null;
            this.data.marital_status = this.editItem.marital_status || null;
            if(this.editItem.dob){
                this.data.dob = new Date(this.editItem.dob);
                this.data.age = this.$filters.calculateAge(this.data.dob);
            }
        }
    },
    created(){
        this.getOptionData()
    },
    mounted(){
        this.setAvailableData()
        this.mirrorData = JSON.parse(JSON.stringify(this.data))
    }
}
</script>

<style scoped>
</style>